import { render, staticRenderFns } from "./ClientsAndStores.vue?vue&type=template&id=2f40c9ca&"
import script from "./ClientsAndStores.vue?vue&type=script&lang=js&"
export * from "./ClientsAndStores.vue?vue&type=script&lang=js&"
import style0 from "./ClientsAndStores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports